import { render, staticRenderFns } from "./OwnerRequestTile.vue?vue&type=template&id=28118e92&scoped=true"
import script from "./OwnerRequestTile.vue?vue&type=script&lang=js"
export * from "./OwnerRequestTile.vue?vue&type=script&lang=js"
import style0 from "./OwnerRequestTile.vue?vue&type=style&index=0&id=28118e92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28118e92",
  null
  
)

export default component.exports